var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60078 5.9998L0.700781 2.0998C0.517448 1.91647 0.425781 1.68314 0.425781 1.3998C0.425781 1.11647 0.517448 0.883138 0.700781 0.699805C0.884115 0.516471 1.11745 0.424805 1.40078 0.424805C1.68411 0.424805 1.91745 0.516471 2.10078 0.699805L6.70078 5.2998C6.80078 5.3998 6.87161 5.50814 6.91328 5.6248C6.95495 5.74147 6.97578 5.86647 6.97578 5.9998C6.97578 6.13314 6.95495 6.25814 6.91328 6.3748C6.87161 6.49147 6.80078 6.5998 6.70078 6.6998L2.10078 11.2998C1.91745 11.4831 1.68411 11.5748 1.40078 11.5748C1.11745 11.5748 0.884115 11.4831 0.700781 11.2998C0.517448 11.1165 0.425781 10.8831 0.425781 10.5998C0.425781 10.3165 0.517448 10.0831 0.700781 9.89981L4.60078 5.9998Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.ac4af61a279b73a871f2d066d2385007.svg";
export { ForwardRef as ReactComponent };